export default __webpack_public_path__ + "static/media/css3.166cdf34.svg";